import { type DocumentPages, resolveDocumentItems } from './documentsDataResolver';

export type DocumentItemProps = {
    title: string;
    topic?: string[];
    category?: string[];
    summary?: React.ReactNode | string;
    downloadUrl?: string;
    url?: string;
    fileType?: string;
    fileSize?: string;
    type?: string;
};

interface DocumentsListingData {
    total: number;
    items: DocumentItemProps[];
}

export const resolveDocumentsListing = (data: DocumentsListingData): DocumentsListingData | null => {
    const { items, total } = data;

    return {
        total: Number(total),
        items: resolveDocumentItems(items as DocumentPages[]),
    };
};
